import { render, staticRenderFns } from "./Ingredientes.vue?vue&type=template&id=1180f57c"
import script from "./Ingredientes.vue?vue&type=script&lang=js"
export * from "./Ingredientes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports